import { Utils } from '../../app.base';
import { MsgBox, Vue } from '../../app.vues';

import devcApi from '../../api/devc';

import SwbAssetDeprRecList from './AssetDeprRecList';
Vue.regist(SwbAssetDeprRecList);

// onlyQueryFailed 仅查询错误数据
export function openAssetDeprRecListDlg(formId, onlyQueryFailed) {
    onlyQueryFailed = Utils.isTrue(onlyQueryFailed);
    let theDlg = Vue.$showDialog({
        title: "折旧单-详情",
        width: -200,
        height: 900,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-asset-depr-rec-list :formId="formId" :onlyQueryFailed="onlyQueryFailed" ref="swb_asset_depr_rec_list"></swb-asset-depr-rec-list>',
        data: {
            formId: formId,
            onlyQueryFailed: onlyQueryFailed
        },
    });
}

import SwbAssetDeprPlanItemList from './AssetDeprPlanItemList'
Vue.regist(SwbAssetDeprPlanItemList);
//
export function openAssetDeprPlanItemListDlg(params) {
    let formId = params['formId'] || null;
    let execState = params['execState'];
    let onlyExtraDepr = params['onlyExtraDepr'];
    onlyExtraDepr = onlyExtraDepr == null ? null : Utils.isTrue(onlyExtraDepr);
    let theDlg = Vue.$showDialog({
        title: "折旧计划",
        width: -200,
        height: 900,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-asset-depr-plan-item-list :formId="formId" :execState="execState" :onlyExtraDepr="onlyExtraDepr" ref="swb_asset_depr_plan_item_list"></swb-asset-depr-plan-item-list>',
        data: {
            formId: formId,
            execState: execState,
            onlyExtraDepr: onlyExtraDepr
        },
    });
}

import SwbAssetDeprResult from './AssetDeprResult';
Vue.regist(SwbAssetDeprResult);
// 折旧测试结果
export function openAssetDeprResultDlg(params, parentSelf) {
    let realComCount = params['realComCount'] || 0;
    let formId = params['formId'] || null;
    let deprMonth = params['deprMonth'] || null;
    let extracted = params['extracted'] == null ? false : Utils.isTrue(params['extracted']);
    let assetDeprResultList = params['assetDeprResultList'] || [];
    let okVisible = true;
    if(Utils.isTrue(extracted)) {
        okVisible = false;
    }
    let theDlg = Vue.$showDialog({
        title: "折旧测试 - 结果",
        width: 1100,
        height: 800,
        showCloseBtn: true,
        okVisible: okVisible,
        okText: "计提并关闭",
        cancelText: "关闭",
        template: '<swb-asset-depr-result :realComCount="realComCount" :formId="formId" :deprMonth="deprMonth" :extracted="extracted" :assetDeprResultList="assetDeprResultList" ref="swb_asset_depr_result"></swb-asset-depr-result>',
        data: {
            realComCount: realComCount,
            formId: formId,
            deprMonth: deprMonth,
            extracted: extracted,
            assetDeprResultList: assetDeprResultList
        },
        okClicked: function () {
            let self = this;
            let result = self.$refs.swb_asset_depr_result.getDlgResult() || {};
            if(result.type === 'info') {
                let resultData = result.data || {};
                //
                self.$confirm(result.msg, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(function () {
                    //
                    let postData = {
                        realComIds: resultData.realComIds,
                        deprMonth: resultData.deprMonth
                    };
                    let theLoad = MsgBox.loading();
                    devcApi.doAssetDeprRecExtracted(postData, function (result) {
                        theLoad.hide();
                        let callback = function () {
                            parentSelf.getAssetDeprFormList();
                        };
                        if(result.type === "info") {
                            //
                            setTimeout(function () {
                                MsgBox.success("计提任务已发送，请等待计提结果！", {callback: callback});
                            }, 500);
                            theDlg.close();
                        } else {
                            MsgBox.warning(result.message);
                            return false;
                        }
                    });
                }).catch(function () {
                });
            } else {
                MsgBox.warning(result.message);
            }
            return false;
        }
    });
}

import SwbAssetDeprPlanReport from './AssetDeprPlanReport';
Vue.regist(SwbAssetDeprPlanReport);
// 折旧计划报表
export function openAssetDeprPlanReportDlg(params) {
    let showTab = params['showTab'];
    showTab = showTab == null ? true : Utils.isTrue(showTab);
    let assetInfo = params['assetInfo'] || null;
    let theDlg = Vue.$showDialog({
        title: "折旧测试 - 结果",
        width: -200,
        height: -100,
        showCloseBtn: true,
        okVisible: false,
        cancelText: "关闭",
        template: '<swb-asset-depr-plan-report :showTab="showTab" :assetInfo="assetInfo" ref="swb_asset_depr_result"></swb-asset-depr-plan-report>',
        data: {
            showTab: showTab,
            assetInfo: assetInfo
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/compo/assetDepr/showDlg.js
// module id = 242
// module chunks = 0